import { NewsLetterHeader } from '@arvesta-websites/icons';

import type { Config } from '../default-config';
import mergeConfig from '../merge-config';

const config: Config = mergeConfig({
  NewsletterHeader: {
    SVG: NewsLetterHeader.AveveAgrarisch,
    className: 'newsletter-svg',
  },
  breadcrumb: {
    display: true,
  },
  button: {
    dealerOverview: {
      details: 'primary',
      navigation: 'primary-with-background',
    },
  },
  footer: {
    differentLogo: true,
    version: 'V2',
  },
});

export default config;
